"use client";

import { usePathname } from "next/navigation";
import MobileFooter from "@/components/mobileFooter";
import { isMemberPreviewPath } from "@kkeut/lib/member-preview-route";

export default function ConditionalMobileFooter({ initialInfo }) {
  const pathname = usePathname();

  // 시술 상세에서는 모바일 푸터를 숨긴다. 로그인·마이페이지도 마찬가지인데,
  // 그 라우트가 없는 지점에서는 isMemberPreviewPath 가 언제나 false 다 (#869).
  const isHidden = pathname?.includes("/clinicPrice") || isMemberPreviewPath(pathname);
  if (isHidden) return null;

  return <MobileFooter initialInfo={initialInfo} />;
}
